module.exports = __webpack_public_path__ + "static/media/CostSaving.410c0a76.svg";